import React from 'react'
import { lower } from 'change-case'
import { connect } from 'react-redux'
import { getFormValues, Field } from 'redux-form'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { FileUploadCell } from 'components'

import { AttachmentFormContainer, FieldFileInput } from './styled'

const RFQAttachment = props => {
  const { valueForm, change, sapDetails } = props
  const { documentTypes } = sapDetails
  
  if(documentTypes){
    var countAttachLine = null
    var documentTypesFilter = documentTypes
    // if(valueForm.isAdditionalPr){
    //   documentTypesFilter = documentTypes.filter(x=>x.isAdditional===true)
    //   if(documentTypesFilter.length===1){
    //     documentTypesFilter = documentTypesFilter = documentTypes.filter(x=>x.isAdditional===false)
    //   }
    //   countAttachLine = Array(Math.ceil(documentTypesFilter.length / 3)).fill(1)
    // }else{
    //   documentTypesFilter = documentTypes.filter(x=>x.isAdditional===false)
    //   countAttachLine = Array(Math.ceil(documentTypesFilter.length / 3)).fill(1)
    // }
    countAttachLine = Array(Math.ceil(documentTypesFilter.length / 3)).fill(1)
  }

  return (
    <React.Fragment>
      {!sapDetails ? (
        null
      ) : (
        <React.Fragment>
          {countAttachLine&&countAttachLine.map((v, i1) => {
            return (
              <AttachmentFormContainer key={i1}>
                {documentTypesFilter.map((dt, i2) => {
                  if (Math.floor(i2 / 3) === i1) {
                    return (
                      <FieldFileInput className='fieldFileInput' key={i2}>
                        <Field
                          name={lower(dt.code)}
                          label={dt.name}
                          type={type.file}
                          component={FieldInput}
                        />
                        <div style={{ flex: 1 }}>
                          {props.sapDetails
                            ? valueForm.rfqAttachments.filter( x => x.documentTypeCode.toLowerCase() === dt.code.toLowerCase() && !x.deleted ).map((item, i3) => (
                                  <div className='oldFile'><FileUploadCell
                                    key={`${item.originalFilename}${i3}`}
                                    fileName={item.originalFilename}
                                    fileSize={item.size}
                                    urlPath={item.urlPath}
                                    onClickDelete={() => {
                                      let index = valueForm.rfqAttachments.findIndex(x => x.filename=== item.filename)
                                      change(`rfqAttachments[${index}].deleted`,true)
                                    }}
                                  /></div>
                                ))
                            : null}
                        </div>
                      </FieldFileInput>
                    )
                  } else {
                    return null
                  }
                })}
              </AttachmentFormContainer>
            )
          })}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const valueForm = getFormValues('formRFQ')(state)
  return {
    sapDetails: state.rfq.sapDetails.data||{},
    valueForm
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(RFQAttachment)
